import React from 'react';

import dayjs, { Dayjs } from 'dayjs';
import styled from 'styled-components';

import DatePicker from 'components/lib/DatePicker';

import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_KEYS } from './constants';

const TextContainer = styled.div`
  margin: 10px 0;
`;

const Label = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Text = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const CompaniesCreateEditModalContentMysteryShoppingTrialShop = () => {
  const { company, handleChange } = useCompaniesCreateEditModalContext();
  const shopRequests = company.shop_requests && company.shop_requests[0];
  const shopRequestDate = shopRequests?.shop_request_date;

  const handleDateChange = (date: Dayjs) => {
    const shop_request_date = date.toDate();
    handleChange(COMPANY_KEYS.SHOP_REQUESTS, [{ shop_request_date }]);
  };

  return (
    <div>
      <TextContainer>
        <Label>Trial Shop</Label>
        <Text>
          Trial mystery shopping will run according on the date defined below. Note that all
          <br />
          competitors of the community participating in a shop will participate as well.
        </Text>
      </TextContainer>
      <Label>Shop Date</Label>
      <DatePicker value={shopRequestDate ? dayjs(shopRequestDate) : null} onChange={handleDateChange} />
    </div>
  );
};

export default CompaniesCreateEditModalContentMysteryShoppingTrialShop;
